import { Pipe, PipeTransform } from '@angular/core';
import { Student } from '../models/student';
import { Course } from '../models/course';

@Pipe({
  name: 'enroll'
})
export class EnrollPipe implements PipeTransform {

  transform(student: Student): string;
  transform(course: Course): string;

  transform(value: Student | Course): string {
    const now = new Date();

    if ('enrollments' in value) {
      return value.enrollments?.length
        ? value.enrollments
            .filter(e => new Date(e.begin) < now && new Date(e.end) > now)
            .map(e => e.name)
            .join(', ')
        : '';
    }

    if ('students' in value) {
      return value.students?.length
        ? value.students
            .filter(s => new Date(s.begin) < now && new Date(s.end) > now)
            .map(s => `${s.firstname} ${s.lastname}`)
            .join(', ')
        : '';
    }

    return '';
  }
}
